import URLS from '../../../source/shared/constants/urls'

export const getAppointmentOriginPath = state => {
  if (state.persistentData && state.persistentData.schedulingType) {
    return state.persistentData.schedulingType === 'mam' ? URLS.gatewayPageUrl : URLS.findADoctorUrl
  }
}

export const getSchedulingType = state => state.persistentData.schedulingType
